import i18next from 'i18next';
import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import fb from '../../assets/images/fb.svg';
import linkdin from '../../assets/images/linkdin.svg';
import qr from '../../assets/images/qr.jpg';
import wC from '../../assets/images/wechat.svg';
import yt from '../../assets/images/yt.svg';
import i18n from '../../i18n/config';
import { getOutsideUrl } from '../../utils/getOutsideUrl';
import './index.css';

interface Props {}

const links = [
  {
    src: linkdin,
    alt: 'Linkdin',
    lang: ['en', 'de', 'it', 'fi', 'fr'],
    handleClick: () => {
      window.open('https://www.linkedin.com/company/trelleborgavs/');
    },
  },
  {
    src: yt,
    alt: 'Youtube',
    lang: ['en', 'de', 'it', 'fi', 'fr'],

    handleClick: () => {
      window.open('https://www.youtube.com/channel/UCviC6WqGOlbK5wcqw7EyBmg');
    },
  },
  // {
  //   src: fb,
  //   alt: 'Facebook',
  //   lang: ['en', 'de', 'it', 'fi', 'zh'],

  //   handleClick: () => {
  //     window.open('https://www.facebook.com/Trelleborggroup');
  //   },
  // },
  {
    src: wC,
    alt: 'WeChat',
    handleClick: (cb: any) => {
      cb(true);
    },
    lang: ['zh'],
  },
];

const Footer: React.FC<Props> = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  return (
    <footer className="tb-footer px-3 py-3  md:px-4 md:py-3 lg:px-5 lg:py-3">
      <section className="tb-footer__start flex flex-column md:flex-row justify-content-between py-5">
        <div className="flex flex-column">
          <div className="text-xs" style={{ marginBottom: '10px' }}>
            Trelleborg Antivibration Solutions
          </div>
          <div className="text-xs mt-2 md:mt-4">{t('RIGHTS')}</div>
        </div>
        <div className="align-self-end">
          <div
            className="font-bold text-right line-height-1 mb-3"
            style={{ fontSize: '15px' }}
          >
            {t('FOLLOW')}
          </div>
          <div className="flex mt-2 justify-content-start md:justify-content-end">
            {links
              .filter((link) => link.lang.includes(i18n.language))
              .map((link, i) => (
                <button
                  key={i}
                  style={{ border: 'none' }}
                  className={i !== 0 ? 'pl-2 cursor-pointer' : 'cursor-pointer'}
                  onClick={() =>
                    link.handleClick(
                      link.alt === 'WeChat' ? setVisible : undefined
                    )
                  }
                >
                  <img width={32} height={32} src={link.src} alt={link.alt} />
                </button>
              ))}
          </div>
        </div>
      </section>

      <ul className="tb-footer__end py-3 flex justify-content-center align-items-center text-xs">
        <li>
          <a
            href={'#'}
            data-variantitemid="{276FA04C-D9B4-47A9-879A-EEB6A2CC7C86}"
            data-variantfieldname="Link"
            className="text-xs cursor-pointer font-weight-500"
            onClick={() => {
              return i18next.language === 'zh'
                ? window.open(
                    'https://www.trelleborg.cn/zh-cn/anti-vibration-solutions/cookie-policy'
                  )
                : (window as any).openCookiePolicyInBanner();
            }}
          >
            {t('COOKIE')}
          </a>
        </li>

        <li className="dot">
          <a
            target={'_blank'}
            href={getOutsideUrl('privacy')}
            className="text-xs cursor-pointer font-weight-500"
            rel="noreferrer"
          >
            {t('PRIV_NO')}
          </a>
        </li>

        <li className="dot">
          <a
            target={'_blank'}
            href={getOutsideUrl('terms')}
            className="text-xs cursor-pointer font-weight-500"
            rel="noreferrer"
          >
            {t('TERM')}
          </a>
        </li>

        <li className="dot">
          <a
            target={'_blank'}
            href={getOutsideUrl('contact')}
            className="text-xs cursor-pointer font-weight-500"
            rel="noreferrer"
          >
            {t('CONTACT_US')}
          </a>
        </li>
      </ul>
      <Dialog
        draggable={false}
        modal
        onHide={() => setVisible(false)}
        visible={visible}
      >
        <section className="flex justify-content-center align-items-center">
          <img className="overflow-hidden" src={qr} alt="QR Code" />
        </section>
      </Dialog>
    </footer>
  );
};

export default Footer;
